import { memo, useMemo } from "react";

import * as UseCase from "@/components/features/setup/model/use-case";

import { Button } from "@/components/ui/button/button";
import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";
import { Label } from "@/components/ui/label/label";

import { useActions } from "./hooks";

export const Setup = memo(() => {
	const { viewModel, onSetViewModel, onCreateHotel } = UseCase.useInitialized();

	const { handleChangeHotelName, handleChangeEmail, handleChangeTotalRoomNum, handleClickCreateHotel } = useActions(
		viewModel,
		onSetViewModel,
		onCreateHotel,
	);

	const hotelNameValue = useMemo(() => viewModel.hotelName.value, [viewModel.hotelName.value]);
	const hotelNameError = useMemo(() => viewModel.hotelName.error, [viewModel.hotelName.error]);
	const emailValue = useMemo(() => viewModel.hotelEmailAddress.value, [viewModel.hotelEmailAddress.value]);
	const emailError = useMemo(() => viewModel.hotelEmailAddress.error, [viewModel.hotelEmailAddress.error]);
	const totalRoomNumValue = useMemo(() => viewModel.totalRoomNum.value, [viewModel.totalRoomNum.value]);
	const totalRoomNumError = useMemo(() => viewModel.totalRoomNum.error, [viewModel.totalRoomNum.error]);
	const disabled = useMemo(() => viewModel.hasError, [viewModel.hasError]);

	return (
		<div className="mx-auto mt-12 w-full max-w-xl px-4 md:px-10">
			<div className="m-auto w-32">
				<img src="/chillnn-logo-black.png" alt="Logo" />
			</div>

			<div className="mt-8 space-y-1">
				<p className="whitespace-pre-wrap text-xl font-medium tracking-widest">
					CHILLNNで２週間の準備期間を始めましょう！
				</p>
				<p className="whitespace-pre-wrap font-medium tracking-widest">※ここでの設定はいつでも変更できます</p>
			</div>

			<div className="mt-5 space-y-4">
				<div className="space-y-2">
					<Label text="必須" size="sm" />
					<InputTextField
						label="ホテル名"
						placeholder="チルンホテル"
						value={hotelNameValue}
						errorMessage={hotelNameError}
						handleChange={handleChangeHotelName}
					/>
				</div>

				<div className="space-y-2">
					<Label text="必須" size="sm" />
					<InputTextField
						label="ホテルメールアドレス"
						placeholder="sample@chillnn.com"
						value={emailValue}
						errorMessage={emailError}
						handleChange={handleChangeEmail}
					/>
				</div>

				<div className="space-y-2">
					<Label text="必須" size="sm" />
					<div className="flex items-center gap-x-4">
						<InputNumberField
							label="施設の部屋数"
							value={totalRoomNumValue}
							errorMessage={totalRoomNumError}
							hiddenSpinButton={false}
							handleInput={handleChangeTotalRoomNum}
						/>
						<p className="mt-6">部屋</p>
					</div>
				</div>
			</div>

			<div className="mt-12 text-center">
				<Button
					type="button"
					variant="default"
					className="w-40"
					disabled={disabled}
					onClick={handleClickCreateHotel}
				>
					登録
				</Button>
			</div>
		</div>
	);
});
